import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import moment from 'moment'

import { Modal } from 'components/Modal'
import { Form } from 'components/forms'
import { DateIntervalForm } from 'components/shared/DateIntervalForm'
import { CardItemList } from 'components/Card'
import Button from 'components/Button'
import Divider from 'components/Divider'
import localDateFormatter from 'helpers/localDateFormatter'

const TimePeriodFilter = (props) => {
	const { onChange, value, label = false, emptyLabel = '', onRemoveItem = null, startValue = false } = props
	const [showModal, setShowModal] = useState(false)
	const [t, language] = useTranslation()
	const handleSave = ({ period }) => {
		setShowModal(null)
		onChange(period)
	}

	const initialPeriod = {
		from: moment().utc().startOf('day').toISOString(),
		to: moment().utc().endOf('day').toISOString()
	}
	return(
		<>
			<CardItemList
				items={[{
					name: value?.to && value?.from ? `${localDateFormatter({ date: value.from, language })} - ${localDateFormatter({ date: value.to, language })}` : `${emptyLabel}`
				}]}
				ItemComponent={({ item }) => item?.name || null}
				height={200}
				label={label ? label : t('common.strings.date_period')}
				onAddItem={() => setShowModal(true)}
				styleInverted
				onRemoveItem = {value?.to && value?.from ? onRemoveItem : false}
			/>
			{showModal &&
				<Modal label={t('statistic_section.strings.separate_days')} width={500} unmount={() => setShowModal(null)}>
					<Form initialValues={{ period: !value?.from && !value?.to && startValue ? initialPeriod : value }} onSubmit={handleSave}>
						<DateIntervalForm maxDate={moment().utc()}/>
						<Divider/>
						<Button type='submit' text={t('common.buttons.apply')} />
					</Form>
				</Modal>
			}
		</>
	)
}

export default TimePeriodFilter
